export const status = {
  edit: 0,
  prod: 1
}

export const StreamContentStatus = {
  INIT: 0
}
